export default "__VITE_ASSET__ChdE_p4u__"